import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

export const DEFAULT_CONFIRM_MODAL_WIDTH: { width: string } = {
  width: '390px'
};

interface DialogData {
  title?: string;
  description?: string;
  confirmButtonText?: string;
}

@Component({
    selector: 'jplus-confirm-modal',
    templateUrl: './confirm-modal.component.html',
    styleUrls: ['./confirm-modal.component.scss'],
    imports: [MatButtonModule, MatDialogModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfirmModalComponent {
  private readonly _dialogRef = inject(MatDialogRef<ConfirmModalComponent>);
  readonly data = inject<DialogData | undefined>(MAT_DIALOG_DATA);

    actionInput(action: boolean) {
    this._dialogRef.close({ success: action });
  }
}
